import { configureStore, ThunkAction, Action, getDefaultMiddleware } from "@reduxjs/toolkit";
import authSlice from "./authSlice";
import settingsSlice from "./settingsSlice";
import toastSlice from "./toastSlice";
import notificationsSlice from './notificationsSlice'

export const store = configureStore({
    reducer: {
        auth: authSlice,
        settings: settingsSlice,
        toast: toastSlice,
        agentNotification: notificationsSlice,
    },
    middleware: [
        ...getDefaultMiddleware({
            serializableCheck: false
        }),
    ],
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
